import { OnlyBotAnchor } from '@animavirtuality/onlybots-core';

// do any global anchor modification here
export const processAnchor = (anchor: OnlyBotAnchor): OnlyBotAnchor => ({
    ...anchor,
    y: anchor.y > 1 ? 1 : anchor.y,
});
